import {
  OrderDirection,
  commonMutationTypes,
  commonPaginationTypes,
  pageInfo,
} from "../../../../../utils/commonQueryTypes";

export enum CaseStudiesOrderField {
  CREATED_AT = "CREATED_AT",
  TITLE = "TITLE",
}

export interface CaseStudiesOrder {
  direction: OrderDirection;
  field: CaseStudiesOrderField;
}

export interface GetCaseStudiesVar extends commonPaginationTypes {
  customerID: number;
  empID: number;
  startDate?: string;
  endDate?: string;
  orderBy: CaseStudiesOrder;
  name: string;
  caseType:string;
}

export interface CaseStudyNode {
  id: number;
  title: string;
  startDate: string;
  endDate: string;
  synopsis: string;
  documents: string;
  caseType: string;
}

export interface CaseStudiesEdge {
  node: CaseStudyNode;
}

export interface GetCaseStudiesData {
  GetCaseStudies: {
    edges: CaseStudiesEdge[];
    pageInfo: pageInfo;
    totalCount: number;
  };
}

export interface CreateCaseStudies {
  title: string;
  startDate: string;
  endDate: string;
  synopsis: string;
  documents: string;
  caseType: string;
}

export interface UpdateCaseStudies {
  title: string;
  startDate: string;
  endDate: string;
  synopsis: string;
  documents: string;
  caseType: string;
}

export interface AddCaseStudyVar extends commonMutationTypes {
  customerID: number;
  input: CreateCaseStudies;
}

export interface UpdateCaseStudyVar extends commonMutationTypes {
  caseStudyID: number;
  input: UpdateCaseStudies;
}

export interface DeleteCaseStudyVar extends commonMutationTypes {
  caseStudyID: number;
}

export interface AddCaseStudyData {
  AddCaseStudy: {
    id: number;
  };
}

export interface UpdateCaseStudyData {
  UpdateCaseStudy: {
    id: number;
  };
}

export interface DeleteCaseStudyData {
  DeleteCaseStudy: boolean;
}

export interface GetCaseTypeVars {
  token: string;
  customerID: number;
}
export interface GetCaseTypeData {
  GetCaseTypes: string[];
}

export interface CommonChooseProps {
  label?: string;
  type?: string;
  ref?: React.RefObject<HTMLDivElement | null>;
  required?: boolean;
  multiline?: boolean;
  rows?: number;
  error?: string;
  name?: string;
  value?: string;
  onBlur?:
    | React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
  disabled?: boolean;
  autoFocus?: boolean;
  openOnFocus?: boolean;
  initialSearchData?: string;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  clearFunction: () => void;
  selectedId?: number;
}
